<template>
    <div class="course-recommend">
        <div class="flex-between title">
            <span class="fs-24 tc-black">为你推荐</span>
            <div class="tc-grey flex-between fs-12">
                <span class="icon prev tl pointer el-icon-arrow-left" @click="handlePrev"></span>
                <span>{{page.page}}/{{page.pagetotal}}</span>
                <span class="icon next tr pointer el-icon-arrow-right" @click="handleNext"></span>
            </div>
        </div>
        <div class="recommend-box flex-start">
            <div class="out-box flex-center" v-for="(obj,i) in datalist" :key="i" @click="handleClick(obj)">
                <div class="box pointer">
                    <div class="img-box"><img class="img" v-lazy="obj.coverurl" alt=""></div>
                    <div class="inner-box">
                        <div class="subject text-ellipses fs-16">{{obj.subject}}</div>
                        <div class="tc-red fs-14">{{(obj.saleprice*1)==0?'免费':'￥'+ obj.saleprice}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import {getIndexCourse} from 'api/indexApi'
  export default {
    name: 'course-recommend',
    data() {
      return {
        datalist: [],
        datasourcelist: [],
        page: {
          page: 1,
          pagesize: 5,
          pagetotal: 0
        }
      }
    },
    mounted() {
      this._getList()
    },
    methods: {
      handleClick(obj) {
        if (obj.kmctype == 8) {
          const {href} = this.$router.resolve({
            name: "QuestionDetails",
            query: {
              qid: obj.innerid
            }
          })
          window.open(href, '_blank');
        } else if (obj.kmctype == 7) {
          const {href} = this.$router.resolve({
            name: "CourseDetails",
            query: {
              cid: obj.innerid,
              chid: ''
            }
          })
          window.open(href, '_blank');
        } else {
          const {href} = this.$router.resolve({
            name: "ReportDetails",
            query: {
              reportid: obj.innerid
            }
          })
          window.open(href, '_blank');
        }
      },
      handlePrev() {
        if (this.page.page == 1) return false
        this.page.page--
        this.datalist = this.datasourcelist.slice((this.page.page-1) * 5, this.page.page * 5)
      },
      handleNext() {
        if (this.page.page == this.page.pagetotal) return false
        this.page.page++
        this.datalist = this.datasourcelist.slice((this.page.page-1) * 5, this.page.page * 5)
      },
      _getList() {
        this.setLoading(true)
        getIndexCourse({
          data: {ruletype: 5},
          success: data=> {
            this.setLoading(false)
            this.datasourcelist = data.data.content
            this.datalist = this.datasourcelist.slice(0, this.page.page * 5)
            this.page.pagetotal = Math.ceil(data.data.content.length / this.page.pagesize)
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      },
      ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .course-recommend {
        .title{
            margin: 30px 0 20px 0;
            .icon{
                width: 20px;
            }
        }
        .recommend-box{
            height: 250px;
        }
        .out-box{
            width: 240px;
            min-width: 240px;
            height: 244px;
        }
        .out-box+.out-box{
        }
        .box{
            width: 220px;
            height: 220px;
            background: #FFFFFF;
            border-radius: 4px;
            overflow: hidden;
            .img-box{
                width: 100%;
                height: 124px;
                .img{
                    width: 100%;
                    height: 100%;
                }
            }
            .inner-box{
                box-sizing: border-box;
                padding: 10px;
                line-height: 25px;
                height: 96px;
                .subject{
                    height: 50px;
                    margin-bottom: 6px;
                }
            }
            &:hover{
                /*width: 240px;*/
                /*height: 244px;*/
                transition: all .5s;
                box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
                transform: scale(1.1);
                /*.img-box{*/
                    /*animation: scale_item3_icon .5s;*/
                    /*transition: all .5s;*/
                    /*transform: scale(1.1);*/
                /*}*/
                /*.inner-box{*/
                    /*height: 106px;*/
                /*}*/
            }
        }
    }
    @keyframes scale_item3_icon {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(1.1);
        }
    }
</style>